import type { Theme } from '@mui/material';

export const paperPaddingStyles = (theme: Theme, responsive = true) => ({
    padding: theme.spacing(3, 5),
    [theme.breakpoints.down('lg')]: {
        padding: responsive ? theme.spacing(2, 3) : undefined,
    },
    [theme.breakpoints.down('md')]: {
        padding: responsive ? theme.spacing(2, 2) : undefined,
    },
    [theme.breakpoints.down('sm')]: {
        padding: responsive ? theme.spacing(2, 1) : undefined,
    },
});

export const insidePaperFullWidthAndHorizontalPaddingStyles = (
    theme: Theme,
    responsive = true,
) => ({
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    marginLeft: responsive ? theme.spacing(-5) : undefined,
    marginRight: responsive ? theme.spacing(-5) : undefined,
    [theme.breakpoints.down('lg')]: {
        paddingLeft: responsive ? theme.spacing(3) : undefined,
        paddingRight: responsive ? theme.spacing(3) : undefined,
        marginLeft: responsive ? theme.spacing(-3) : undefined,
        marginRight: responsive ? theme.spacing(-3) : undefined,
    },
    [theme.breakpoints.down('md')]: {
        paddingLeft: responsive ? theme.spacing(2) : undefined,
        paddingRight: responsive ? theme.spacing(2) : undefined,
        marginLeft: responsive ? theme.spacing(-2) : undefined,
        marginRight: responsive ? theme.spacing(-2) : undefined,
    },
    [theme.breakpoints.down('sm')]: {
        paddingLeft: responsive ? theme.spacing(1) : undefined,
        paddingRight: responsive ? theme.spacing(1) : undefined,
        marginLeft: responsive ? theme.spacing(-1) : undefined,
        marginRight: responsive ? theme.spacing(-1) : undefined,
    },
});

export const paperHorizontalPaddingStyles = (
    theme: Theme,
    responsive = true,
) => ({
    paddingLeft: responsive ? theme.spacing(5) : undefined,
    paddingRight: responsive ? theme.spacing(5) : undefined,
    [theme.breakpoints.down('lg')]: {
        paddingLeft: responsive ? theme.spacing(3) : undefined,
        paddingRight: responsive ? theme.spacing(3) : undefined,
    },
    [theme.breakpoints.down('md')]: {
        paddingLeft: responsive ? theme.spacing(2) : undefined,
        paddingRight: responsive ? theme.spacing(2) : undefined,
    },
    [theme.breakpoints.down('sm')]: {
        paddingLeft: responsive ? theme.spacing(1) : undefined,
        paddingRight: responsive ? theme.spacing(1) : undefined,
    },
});

export const paperPaddingLeftStyles = (theme: Theme, responsive = true) => ({
    paddingLeft: theme.spacing(5),
    [theme.breakpoints.down('lg')]: {
        paddingLeft: responsive ? theme.spacing(3) : undefined,
    },
    [theme.breakpoints.down('md')]: {
        paddingLeft: responsive ? theme.spacing(2) : undefined,
    },
    [theme.breakpoints.down('sm')]: {
        paddingLeft: responsive ? theme.spacing(1) : undefined,
    },
});

export const paperPaddingRightStyles = (theme: Theme, responsive = true) => ({
    paddingRight: theme.spacing(5),
    [theme.breakpoints.down('lg')]: {
        paddingRight: responsive ? theme.spacing(3) : undefined,
    },
    [theme.breakpoints.down('md')]: {
        paddingRight: responsive ? theme.spacing(2) : undefined,
    },
    [theme.breakpoints.down('sm')]: {
        paddingRight: responsive ? theme.spacing(1) : undefined,
    },
});
export const paperUndoPaddingLeftStyles = (
    theme: Theme,
    responsive = true,
) => ({
    marginLeft: theme.spacing(-5),
    [theme.breakpoints.down('lg')]: {
        marginLeft: responsive ? theme.spacing(-3) : undefined,
    },
    [theme.breakpoints.down('md')]: {
        marginLeft: responsive ? theme.spacing(-2) : undefined,
    },
    [theme.breakpoints.down('sm')]: {
        marginLeft: responsive ? theme.spacing(-1) : undefined,
    },
});

export const paperUndoPaddingRightStyles = (
    theme: Theme,
    responsive = true,
) => ({
    marginRight: theme.spacing(-5),
    [theme.breakpoints.down('lg')]: {
        marginRight: responsive ? theme.spacing(-3) : undefined,
    },
    [theme.breakpoints.down('md')]: {
        marginRight: responsive ? theme.spacing(-2) : undefined,
    },
    [theme.breakpoints.down('sm')]: {
        marginRight: responsive ? theme.spacing(-1) : undefined,
    },
});

/**
 * Use this to reset the horizontal padding to zero by applying a negative margin
 */
export const insidePaperFullWidthStyles = (
    theme: Theme,
    responsive = true,
) => ({
    marginLeft: theme.spacing(-5),
    marginRight: theme.spacing(-5),
    ...(responsive
        ? {
              [theme.breakpoints.down('lg')]: {
                  marginLeft: theme.spacing(-3),
                  marginRight: theme.spacing(-3),
              },
              [theme.breakpoints.down('md')]: {
                  marginLeft: theme.spacing(-2),
                  marginRight: theme.spacing(-2),
              },
              [theme.breakpoints.down('sm')]: {
                  marginLeft: theme.spacing(-1),
                  marginRight: theme.spacing(-1),
              },
          }
        : {}),
});
